"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCrypto = getCrypto;
function getCrypto() {
    // TODO: remove msCrypto when IE11 support is dropped
    return window.crypto || window.msCrypto;
}
//# sourceMappingURL=crypto.js.map